exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3fY1kFvxX0kmOq{padding-bottom:20px}._3LwU2kFcALXOpu{display:flex;flex-direction:column;will-change:max-height}._3LwU2kFcALXOpu:not(:empty)+._3LwU2kFcALXOpu{padding-top:16px}._3LwU2kFcALXOpu:last-child{padding-bottom:0}.xhTPSx48DVWdC_{font-weight:400;box-shadow:none;margin:0;padding:0;width:100%;text-decoration:underline}.xhTPSx48DVWdC_,.xhTPSx48DVWdC_:active,.xhTPSx48DVWdC_:focus,.xhTPSx48DVWdC_:hover{background:none}.xhTPSx48DVWdC_:hover{color:#091e42}._1h98IR7Xqm00Hn{padding:19px 0}", ""]);

// exports
exports.locals = {
	"highlightSection": "_3fY1kFvxX0kmOq",
	"highlight": "_3LwU2kFcALXOpu",
	"showMoreButton": "xhTPSx48DVWdC_",
	"spinnerWrapper": "_1h98IR7Xqm00Hn"
};